import React, { useState } from 'react';

function MarketRules() {
  const [open, setOpen] = useState(false);

  return (
    <section className="nxl-panel nxl-rules-panel">
      <div className="nxl-section-heading">
        <div>
          <p className="nxl-kicker">HOW THIS WORKS</p>
          <h2>Scheduled-match pool markets</h2>
        </div>

        <button className="nxl-small-button" onClick={() => setOpen((v) => !v)}>
          {open ? 'Hide' : 'Learn More'}
        </button>
      </div>

      <p>
        Only scheduled PBLeagues matches are tradable. Model odds are informational.
        Final payouts are based on the credits wagered on each side.
      </p>

      {open && (
        <>
          <div className="nxl-rules-grid">
            <div>
              <strong>1. Pick a side</strong>
              <span>Choose the team you think will win the scheduled match.</span>
            </div>

            <div>
              <strong>2. Credits enter the pot</strong>
              <span>All stakes for both teams create the matchup pool.</span>
            </div>

            <div>
              <strong>3. House keeps 5%</strong>
              <span>The remaining 95% is distributed to the winning side.</span>
            </div>

            <div>
              <strong>4. Winners split by stake</strong>
              <span>Your payout depends on your share of the winning-side pool.</span>
            </div>
          </div>

          <div className="nxl-rules-warning">
            If all wagers are on one side and there is no losing-side pool, there may be
            no meaningful payout to distribute. Those markets may be refunded, voided,
            or manually reviewed by administrators.
          </div>
        </>
      )}
    </section>
  );
}

export default MarketRules;